import { render, staticRenderFns } from "./ViAdmissionNew.vue?vue&type=template&id=b48c6854"
import script from "./ViAdmissionNew.vue?vue&type=script&lang=js"
export * from "./ViAdmissionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports